/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import { FULFILLED } from 'src/js/common/actions/ActionUtils';
import { deleteCartData, SET_PAYER_TO_STATE } from 'src/js/enrol/actions/Actions';
import { IshState } from 'src/js/services/IshState';


export const EpicSyncCartPayers = (action$: Observable<any>, store: StateObservable<IshState>): any => {
  return action$.pipe(
    ofType(SET_PAYER_TO_STATE),
    mergeMap((action) => {
      const state = store.value;

      return [
        ...state.checkout.payerId ? [deleteCartData(state.checkout.payerId)] : [],
        {
          type: FULFILLED(SET_PAYER_TO_STATE),
          payload: action.payload
        },

      ]
    })
  );
};